const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['代碼維護', 'Parameters', '代码维护'],
				children: {
					ZZ_FARGLORYDOME_PB10710_RCCC: {
						name: ['(客製)成本中心','(客製)Cost Center','(客製)成本中心'],
						url: '/zz_farglorydome_pb10710_rccc',
						hint: [],
					},
				},
			}
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};